// Slow, single editorial marquee. Pure CSS animation, duplicated content
// for a seamless loop. Pauses for reduced-motion users (handled in index.css).
const WORDS = ["Integrity", "Accountability", "Transparency"];
const SEQUENCE = [...WORDS, ...WORDS, ...WORDS, ...WORDS];

function MarqueeRow() {
  return (
    <div className="flex shrink-0 items-center">
      {SEQUENCE.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-2xl sm:text-3xl md:text-4xl text-navy/90">
            {w}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-brand-green" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      aria-label="Our principles"
      className="overflow-hidden border-y border-line bg-cream py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <MarqueeRow />
        <MarqueeRow />
      </div>
    </section>
  );
}
